import React, { useState, createRef } from 'react';
import SymptomSearchMenu from './SymptomSearchMenu';
import * as Front from '../../../assets/Homunculus/Front';
import * as Back from '../../../assets/Homunculus/Back';
import { ReactComponent as RotateIcon } from '../../../assets/RotateIcon.svg';
import '../../../stylesheets/triagebot/SymptomSearchBody.scss';

const SymptomSearchBody = ({ message, tags, setTags, bodyPartHover, setBodyPartHover, disabled, HoverColor }) => {
    const [showMenu, setShowMenu] = useState(false);
    const [bodyPart, setBodyPart] = useState(false);
    const [bodyPartQueryTerm, setBodyPartQueryTerm] = useState();
    const [showBack, setShowBack] = useState(false);

    const container = createRef();

    const age = (message?.data?.[0]?.userAge)
        ? message.data[0].userAge
        : 42;

    const gender = (message?.data[0]?.userSex)
        ? message.data[0].userSex
        : 'male';

    const rotateText = (message?.data?.[0]?.rotateText)
        ? message.data[0].rotateText
        : '';

    const language= (message?.language)
    ? message?.language
    : '';

    const avatarBodyParts= (message?.data?.[0]?.avatarBodyparts)
    ? message?.data?.[0]?.avatarBodyparts
    : [];

    const inputDisabled = disabled;

    const handleBodyPartClick = (event, bpart, bPartQueryTerm) => {
        if (inputDisabled) return;

        setBodyPart(getBodyPartTitle(bpart));
        setBodyPartQueryTerm(bPartQueryTerm);
        setShowMenu(true);

        return false;
    }

    const tagListContains = (bodypart) => {
        bodypart = bodypart.toLowerCase();

        return tags.filter(tag => { return tag.body_parts.includes(bodypart) }).length;
    }

    const shouldBeHighlighted = (bodypart) => {
        return tagListContains(bodypart) || (bodypart.toLowerCase() === bodyPartHover.toLowerCase());        
    }

    const getBodyPartTitle = (title) => {
        // return title+" jfdfjfjjdjdj";
        return avatarBodyParts?.find((part) => part.name.toLowerCase() === title.toLowerCase())?.value || title;

  };

    return (
        <div ref={container} className={'symptom-body'}>
            <SymptomSearchMenu
                message={message}
                showMenu={showMenu}
                setShowMenu={setShowMenu}
                onClose={() => setShowMenu(false)}
                bodyPart={bodyPart}
                bodyPartQueryTerm={bodyPartQueryTerm}
                age={age}
                gender={gender}
                tags={tags}
                setTags={setTags}
                setBodyPartHover={setBodyPartHover}
                HoverColor={HoverColor}
            />
            {
                showBack
                    ?
                    <div className={inputDisabled ? 'disabled humonculous' : 'humonculous'} >
                        <Back.Body className='back body' />

                        <Back.Head
                            className={shouldBeHighlighted('head') ? 'back head highlight' : 'back head'}
                            title={getBodyPartTitle('head')}
                            onClick={(e) => { handleBodyPartClick(e, 'head', 'Head') }}
                        />

                        <Back.Ears
                            className={shouldBeHighlighted('ears') ? 'back ears highlight' : 'back ears'}
                            title={getBodyPartTitle('ears')}
                            onClick={(e) => { handleBodyPartClick(e, 'ears', 'Ears') }}
                        />
                  
                        <Back.NeckOrThroat
                            className={shouldBeHighlighted('neck or throat') ? 'back neckorthroat highlight' : 'back neckorthroat'}
                            title={getBodyPartTitle('neckorthroat')}
                            onClick={(e) => { handleBodyPartClick(e, 'neckorthroat', 'Neck or throat') }}
                        />

                        <Back.NapeOfNeck
                            className={shouldBeHighlighted('nape of neck') ? 'back napeofneck highlight' : 'back napeofneck'}
                            title={getBodyPartTitle('napeofneck')}
                            onClick={(e) => { handleBodyPartClick(e, 'napeofneck', 'Nape of neck') }}
                        />

                        <Back.UpperArm
                            className={shouldBeHighlighted('upper arm') ? 'back upperarms highlight' : 'back upperarms'}
                            title={getBodyPartTitle('upperarms')}
                            onClick={(e) => { handleBodyPartClick(e, 'upperarms', 'Upper arm') }}
                        />

                        <Back.Elbows
                            className={shouldBeHighlighted('elbow') ? 'back elbows highlight' : 'back elbows'}
                            title={getBodyPartTitle('elbow')}
                            onClick={(e) => { handleBodyPartClick(e, 'elbow', 'Elbow') }}
                        />

                        <Back.Forearm
                            className={shouldBeHighlighted('forearm') ? 'back forearm highlight' : 'back forearm'}
                            title={getBodyPartTitle('forearm')}
                            onClick={(e) => { handleBodyPartClick(e, 'forearm', 'Forearm') }}
                        />

                        <Back.Hands
                            className={shouldBeHighlighted('hand') ? 'back hands highlight' : 'back hands'}
                            title={getBodyPartTitle('hands')}
                            onClick={(e) => { handleBodyPartClick(e, 'hand', 'Hand') }}
                        />

                        <Back.Back
                            className={shouldBeHighlighted('back') ? 'back baack highlight' : 'back baack'}
                            title={getBodyPartTitle('back')}
                            onClick={(e) => { handleBodyPartClick(e, 'back', 'Back') }}
                        />

                        <Back.LowerBack
                            className={shouldBeHighlighted('lower back') ? 'back lowerback highlight' : 'back lowerback'}
                            title={getBodyPartTitle('lowerback')}
                            onClick={(e) => { handleBodyPartClick(e, 'lowerback', 'Lower back') }}
                        />

                        <Back.Buttocks
                            className={shouldBeHighlighted('buttocks') ? 'back buttocks highlight' : 'back buttocks'}
                            title={getBodyPartTitle('buttocks')}
                            onClick={(e) => { handleBodyPartClick(e, 'buttocks', 'Buttocks') }}
                        />

                        <Back.Thighs
                            className={shouldBeHighlighted('thigh') ? 'back thighs highlight' : 'back thighs'}
                            title={getBodyPartTitle('thighs')}
                            onClick={(e) => { handleBodyPartClick(e, 'thighs', 'Thigh') }}
                        />

                        <Back.Knees
                            className={shouldBeHighlighted('knee') ? 'back knees highlight' : 'back knees'}
                            title={getBodyPartTitle('knees')}
                            onClick={(e) => { handleBodyPartClick(e, 'knees', 'Knee') }}
                        />

                        <Back.LowerLegs
                            className={shouldBeHighlighted('lower leg') ? 'back lowerlegs highlight' : 'back lowerlegs'}
                            title={getBodyPartTitle('lowerlegs')}
                            onClick={(e) => { handleBodyPartClick(e, 'lowerlegs', 'Lower leg') }}
                        />

                        <Back.Foot
                            className={shouldBeHighlighted('foot') ? 'back foot highlight' : 'back foot'}
                            title={getBodyPartTitle('foot')}
                            onClick={(e) => { handleBodyPartClick(e, 'foot', 'Foot') }}
                        />

                    </div>
                    :
                    <div className={inputDisabled ? 'disabled humonculous' : 'humonculous'}>
                        <Front.Body className='front body' />

                        <Front.Head
                            className={shouldBeHighlighted('head') ? 'front head highlight' : 'front head'}
                            title={getBodyPartTitle('head')}
                            onClick={(e) => { handleBodyPartClick(e, 'head', 'Head') }}
                        />

                        <Front.Ears
                            className={shouldBeHighlighted('ears') ? 'front ears highlight' : 'front ears'}
                            title={getBodyPartTitle('ears')}
                            onClick={(e) => { handleBodyPartClick(e, 'ears', 'Ears') }}
                        />

                        <Front.Eyes
                            className={shouldBeHighlighted('eyes') ? 'front eyes highlight' : 'front eyes'}
                            title={getBodyPartTitle('eyes')}
                            onClick={(e) => { handleBodyPartClick(e, 'eyes', 'Eyes') }}
                        />

                        <Front.Nose
                            className={shouldBeHighlighted('nose') ? 'front nose highlight' : 'front nose'}
                            title={getBodyPartTitle('nose')}
                            onClick={(e) => { handleBodyPartClick(e, 'nose', 'Nose') }}
                        />

                        <Front.Mouth
                            className={shouldBeHighlighted('oral cavity') ? 'front mouth highlight' : 'front mouth'}
                            title={getBodyPartTitle('oralcavity')}
                            onClick={(e) => { handleBodyPartClick(e, 'oralcavity', 'Oral cavity') }}
                        />

                        <Front.Neck
                            className={shouldBeHighlighted('neck or throat') ? 'front neck highlight' : 'front neck'}
                            title={getBodyPartTitle('neckorthroat')}
                            onClick={(e) => { handleBodyPartClick(e, 'neckorthroat', 'Neck or throat') }}
                        />

                        <Front.UpperArms
                            className={shouldBeHighlighted('upper arm') ? 'front upperarms highlight' : 'front upperarms'}
                            title={getBodyPartTitle('upperarms')}
                            onClick={(e) => { handleBodyPartClick(e, 'upperarms', 'Upper arm') }}
                        />

                        <Front.Forearm
                            className={shouldBeHighlighted('forearm') ? 'front forearm highlight' : 'front forearm'}
                            title={getBodyPartTitle('forearm')}
                            onClick={(e) => { handleBodyPartClick(e, 'forearm', 'Forearm') }}
                        />

                        <Front.Hands
                            className={shouldBeHighlighted('hand') ? 'front hands highlight' : 'front hands'}
                            title={getBodyPartTitle('hands')}
                            onClick={(e) => { handleBodyPartClick(e, 'hands', 'Hand') }}
                        />

                        <Front.Chest
                            className={shouldBeHighlighted('chest') ? 'front chest highlight' : 'front chest'}
                            title={getBodyPartTitle('chest')}
                            onClick={(e) => { handleBodyPartClick(e, 'chest', 'Chest') }}
                        />

                        <Front.UpperAbdomen
                            className={shouldBeHighlighted('upper abdomen') ? 'front upperabdomen highlight' : 'front upperabdomen'}
                            title={getBodyPartTitle('upperabdomen')}
                            onClick={(e) => { handleBodyPartClick(e, 'upperabdomen', 'Upper abdomen') }}
                        />

                        <Front.MiddleAbdomen
                            className={shouldBeHighlighted('mid abdomen') ? 'front middleabdomen highlight' : 'front middleabdomen'}
                            title={getBodyPartTitle('midabdomen')}
                            onClick={(e) => { handleBodyPartClick(e, 'midabdomen', 'Mid abdomen') }}
                        />

                        <Front.LowerAbdomen
                            className={shouldBeHighlighted('lower abdomen') ? 'front lowerabdomen highlight' : 'front lowerabdomen'}
                            title={getBodyPartTitle('lowerabdomen')}
                            onClick={(e) => { handleBodyPartClick(e, 'lowerabdomen', 'Lower abdomen') }}
                        />

                        <Front.Thighs
                            className={shouldBeHighlighted('thigh') ? 'front thighs highlight' : 'front thighs'}
                            title={getBodyPartTitle('thighs')}
                            onClick={(e) => { handleBodyPartClick(e, 'thighs', 'Thigh') }}
                        />

                        <Front.SexualOrgans
                            className={shouldBeHighlighted('sexual organs') ? 'front sexualorgans highlight' : 'front sexualorgans'}
                            title={getBodyPartTitle('sexualorgans')}
                            onClick={(e) => { handleBodyPartClick(e, 'sexualorgans', 'Sexual organs') }}
                        />

                        <Front.Knees
                            className={shouldBeHighlighted('knee') ? 'front knees highlight' : 'front knees'}
                            title={getBodyPartTitle('knees')}
                            onClick={(e) => { handleBodyPartClick(e, 'knees', 'Knee') }}
                        />

                        <Front.LowerLegs
                            className={shouldBeHighlighted('lower leg') ? 'front lowerlegs highlight' : 'front lowerlegs'}
                            title={getBodyPartTitle('lowerlegs')}
                            onClick={(e) => { handleBodyPartClick(e, 'lowerlegs', 'Lower leg') }}
                        />

                        <Front.Foot
                            className={shouldBeHighlighted('foot') ? 'front foot highlight' : 'front foot'}
                            title={getBodyPartTitle('foot')}
                            onClick={(e) => { handleBodyPartClick(e, 'foot', 'Foot') }}
                        />
                    </div>
            }
            <div
                onClick={() => setShowBack(!showBack)}
                className='rotate'
            >
                <RotateIcon className='rotateIcon' transform={showBack ? 'rotate(180) translate(7 -1)' : 'rotate(0)'} />
                <span>{rotateText}</span>
            </div>
        </div>
    );
};

export default SymptomSearchBody;